import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useGetPopularKeywordsQuery } from 'store/api'
import { randomItemsFromList } from '../lib/helpers'

export const usePopularKeywords = (
  totalWords: number = 6,
  reRandomTrigger: any = ''
) => {
  const [randomPopularKeywords, setRandomPopularKeywords] = useState<string[]>(
    []
  )
  const { i18n } = useTranslation()
  const popularKeywords = useGetPopularKeywordsQuery(i18n.language)

  useEffect(() => {
    if (!popularKeywords?.isSuccess || popularKeywords?.isFetching) return

    setRandomPopularKeywords(
      randomItemsFromList(popularKeywords?.data, totalWords).map(
        ({ word }) => word
      )
    )
  }, [totalWords, popularKeywords, reRandomTrigger])

  return randomPopularKeywords
}
